<div id="gift-icon">
<ng-container *ngIf="hasNewGift; else noNewGift">
  <img
    src="../../../../../assets/img/icons8-gift.gif"
    (click)="openGiftsPage()"
  />
</ng-container>
<ng-template #noNewGift>
  <img
    src="../../../../../assets/img/icons8-gift-48.png"
    (click)="openGiftsPage()"
  />
</ng-template>
</div>
